import React from 'react';
import PropTypes from 'prop-types';
import { CheckmarkIconSimple } from '@ui/icons';
import { ProgressBar } from '@web/atoms';
import { BaseHeader } from '@web/molecules';
import {
  StepsWrapper,
  Steps,
  CheckmarkWrapper,
  Step,
  RightSegmentWrapper,
} from './styles';

export const CheckoutHeader = ({
  currentStep,
  rightSegment,
  steps,
  showLogo = true,
  showSteps = true,
}) => {
  const totalSteps = steps.length;
  const currentStepIndex = steps.indexOf(currentStep);
  const topHeaderSegment = (
    <>
      <ProgressBar
        currentStep={currentStepIndex + 1}
        totalSteps={totalSteps}
        labelText={`Checkout step ${currentStepIndex + 1} of ${totalSteps}`}
      />
      {showSteps && (
        <StepsWrapper>
          <div />
          <Steps>
            {steps.map((step, index) => (
              <Step key={step} active={step === currentStep}>
                {index < currentStepIndex && (
                  <CheckmarkWrapper>
                    <CheckmarkIconSimple size="11px" alt="Completed" />
                  </CheckmarkWrapper>
                )}
                {step}
              </Step>
            ))}
          </Steps>
          <RightSegmentWrapper>{rightSegment ?? null}</RightSegmentWrapper>
        </StepsWrapper>
      )}
    </>
  );

  return <BaseHeader showLogo={showLogo} topSegment={topHeaderSegment} />;
};

CheckoutHeader.displayName = 'CheckoutHeader';

CheckoutHeader.propTypes = {
  currentStep: PropTypes.string.isRequired,
  rightSegment: PropTypes.object,
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
  showLogo: PropTypes.bool,
  showSteps: PropTypes.bool,
};
